import React from 'react';
// import Carousel from 'react-material-ui-carousel'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Box, Card, Typography, CardActions, CardMedia, IconButton } from '@mui/material'
import Slider from 'react-slick';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { limpiarTexto } from '../lib/format';


const NextArrow = (props) => {
    const { className, style, onClick } = props;

    return (
        <IconButton
            color="primary"
            onClick={onClick}
            sx={{
                position: 'absolute',
                top: '50%',
                right: '10px',
                transform: 'translateY(-50%)',
                zIndex: 1, // Asegura que la flecha esté por encima del contenido
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Fondo blanco semitransparente
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)', // Fondo blanco sólido al pasar el mouse
                },
                boxShadow: 3, // Sombra para darle más visibilidad
            }}
        >
            <ChevronRight />
        </IconButton>
    );
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <IconButton
            color="primary"
            onClick={onClick}
            sx={{
                position: 'absolute',
                top: '50%',
                left: '10px',
                transform: 'translateY(-50%)',
                zIndex: 1, // Asegura que la flecha esté por encima del contenido
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Fondo blanco semitransparente
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)', // Fondo blanco sólido al pasar el mouse
                },
                boxShadow: 3, // Sombra para darle más visibilidad
            }}
        >
            <ChevronLeft />
        </IconButton>
    );
};

function Carrusel({ items, isOrganismo = false }) {
    const settings = {
        dots: true,
        infinite: items.length > 1 ? true : false,
        autoplay: true,
        autoplaySpeed: 3200,
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 1500,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,

    }

    return (
        <div className="slider-container">
            <Slider {...settings}>
                {
                    items.map((item, i) =>
                        <Item key={i} item={item} isOrganismo={isOrganismo} />
                    )
                }
            </Slider>
        </div>
    )
}

function Item(props) {
    return (
        <Box sx={{
            display: 'flex', width: 'auto', height: '100%', py: 2
        }}>
            {
                [props.item].map((item) => {
                    let direccion = `${item.municipio}, ${item.estado}`
                    return (
                        <Card
                            sx={{
                                mx: 1,
                                width: '100%',
                                minHeight: '400px',
                                maxHeight: '400px',
                                cursor: 'pointer',
                                display: 'flex',
                                flexDirection: 'column', // Asegura que el contenido se apile verticalmente
                                '&:hover': {
                                    boxShadow: 5,
                                    bgcolor: '#fafaff'
                                }
                            }}
                            onClick={() => {
                                // window.open("https://google.com", '_blank')
                                window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${limpiarTexto(item.nombre_comercial).toLowerCase().split(' ').join('-')}`, '_blank')


                            }}
                        >
                            <CardMedia
                                component="img"
                                style={{ height: 'auto', maxHeight: 200, width: '100%', objectFit: 'contain' }}
                                image={Object.values(item.imagenes.datos_generales.galeria)[0]}
                                title="logo"
                            />

                            <Box sx={{ mx: 2, flex: 1 }}> {/* flex: 1 hace que el contenido tome el espacio disponible */}
                                <Typography sx={{ mt: 1, color: '#228586' }} variant="h6">{item.nombre_comercial}</Typography>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography variant="subtitle2" sx={{ lineHeight: 1.3 }}>
                                        {!props.isOrganismo ? item.descripcion.length <= 150 ? item.descripcion :
                                            <>
                                                {item.descripcion.substr(0, 150)} ...<strong>Ver más</strong>
                                            </> : <></>
                                        }
                                    </Typography>
                                </Box>
                            </Box>
                            <CardActions
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    p: 1, // Reduce el espaciado para minimizar el área vacía
                                    mt: 'auto', // Asegura que el CardActions esté al fondo del Card
                                }}
                            >
                                <Box sx={{ width: '100px', height: '60px' }}>
                                    <img src={item.logotipo} style={{ objectFit: 'contain', width: '100%', height: '100%' }} />
                                </Box>
                                <Typography variant="subtitle2">{direccion}</Typography>
                            </CardActions>
                        </Card>

                    )
                })

            }
        </Box >
    )
}

export default Carrusel